module.exports = __webpack_public_path__ + "13-o1.gif?c3d9f6d1669c1a74c44bcce3245f1c4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/13-o1.gif
// module id = 624
// module chunks = 0